import PropTypes from 'prop-types'
import { useState } from 'react'
import { Box, Button, TablePagination, useMediaQuery } from '@material-ui/core'
import { useTheme } from '@material-ui/styles'
import { Plus as PlusIcon } from 'react-feather'
import { reverse } from 'named-urls'
import { useHistory } from 'react-router-dom'

import { useFetch, usePagination, useSnackbar } from 'hooks'

import {
  LinkedDialog,
  PreRegistrationsTable,
  Import,
  GenerateCompany,
} from './components'
import { ButtonComponent, Card, LoadingFeedback } from 'components'
import constants from 'constants/index'

import { routes } from 'Routes'
import * as service from 'service'
import helpers from 'helpers'

const PreRegistrationsCard = ({ paymentContract, mode }) => {
  const history = useHistory()
  const theme = useTheme()
  const snackbar = useSnackbar()
  const [openNew, setOpenNew] = useState(false)
  const [openImport, setOpenImport] = useState(false)
  const [openGenerateCompany, setOpenGenerateCompany] = useState(false)

  const handleCreateUser = () => {
    if (limitCompanies.block)
      return snackbar.open({ message: limitCompanies.message })

    history.push(routes.preRegistrations.new, {
      type: constants.preRegistration.TYPE_REAL,
      typeClient: constants.preRegistration.CLIENT_TYPE,
      parentContractId: paymentContract?.id,
    })
  }

  const handleRedirect = (tab) => {
    const action = mode === 'show' ? 'show' : 'edit'

    return history.push(
      reverse(routes.contracts[action], {
        contractId: paymentContract?.id,
      }),
      { tab },
    )
  }

  const limitCompanies =
    helpers.paymentContract.limitCompaniesValidate(paymentContract)

  const { perPage, page, handleChangePage, handleChangeRowsPerPage } =
    usePagination(5)

  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  })

  const handleLinked = () => {
    if (limitCompanies.block)
      return snackbar.open({ message: limitCompanies.message })
    setOpenNew(true)
  }
  const handleImport = () => {
    if (limitCompanies.block)
      return snackbar.open({ message: limitCompanies.message })
    setOpenImport(true)
  }
  const handleGenerateCompany = () => setOpenGenerateCompany(true)

  const { response, isLoading, refresh } = useFetch(
    service.dponet.paymentContract.preRegistrations,
    {
      paymentContractId: paymentContract?.id,
      params: { perPage, page },
    },
    [page, perPage],
  )

  const paymentContractPreRegistrations =
    response?.data?.paymentContractPreRegistrations || []

  return (
    <>
      <Card
        title="Empresas (pré-cadastro)"
        fromTable
        actionButton={
          <Box display="flex" flexWrap="wrap" alignItems="center" gridGap={8}>
            <Button
              size="small"
              variant="outlined"
              color="primary"
              onClick={handleGenerateCompany}
            >
              Gerar empresa (DPOnet)
            </Button>
            <Button
              size="small"
              variant="outlined"
              color="primary"
              onClick={handleImport}
            >
              Importar
            </Button>
            <Button
              size="small"
              variant="outlined"
              color="primary"
              onClick={handleLinked}
            >
              Vincular
            </Button>
            <Button
              size="small"
              startIcon={<PlusIcon size={16} />}
              variant="contained"
              color="primary"
              onClick={handleCreateUser}
            >
              Criar
            </Button>
          </Box>
        }
      >
        <LoadingFeedback open={isLoading} />
        <PreRegistrationsTable
          paymentContractId={paymentContract?.id}
          paymentContractPreRegistrations={paymentContractPreRegistrations}
          refresh={refresh}
        />
        <Box px={2} display="flex" justifyContent="flex-end">
          <TablePagination
            component="div"
            count={response?.data?.meta?.totalCount || 0}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            page={page - 1}
            rowsPerPage={perPage}
            rowsPerPageOptions={[5, 10, 25, 100]}
            labelRowsPerPage={isDesktop ? 'Por página' : ''}
            nextIconButtonProps={{ size: 'small' }}
            backIconButtonProps={{ size: 'small' }}
          />
        </Box>
      </Card>
      <Box display="flex" justifyContent="flex-end" mt={2}>
        <Box mr={2}>
          <ButtonComponent
            variant="outlined"
            onClick={() => handleRedirect('contract')}
            type="button"
            title="Voltar"
          />
        </Box>
        <ButtonComponent
          onClick={() => handleRedirect('services')}
          type="button"
          title="Próximo"
        />
      </Box>
      {openNew && (
        <LinkedDialog
          paymentContractId={paymentContract?.id}
          preRegistrationIds={paymentContract?.preRegistrationIds}
          refresh={refresh}
          openNew={openNew}
          setOpenNew={setOpenNew}
        />
      )}
      {openImport && (
        <Import
          setOpen={setOpenImport}
          open={openImport}
          paymentContractId={paymentContract?.id}
          refresh={refresh}
        />
      )}
      ,
      {openGenerateCompany && (
        <GenerateCompany
          setOpen={setOpenGenerateCompany}
          open={openGenerateCompany}
          paymentContractId={paymentContract?.id}
          refresh={refresh}
        />
      )}
    </>
  )
}

PreRegistrationsCard.propTypes = {
  paymentContract: PropTypes.object,
  mode: PropTypes.string,
}

export default PreRegistrationsCard
